import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class ContactsResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "contact", `/api/v1/contacts`);
  }
}
